/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuctionCatalogHierarchyDto } from '../../models/auction-catalog-hierarchy-dto';
import { Operation } from '../../models/operation';

export interface PatchAuctionCatalog$Params {
  id: number;
  'X-API-Version'?: string;
      body: Array<Operation>
}

export function patchAuctionCatalog(http: HttpClient, rootUrl: string, params: PatchAuctionCatalog$Params, context?: HttpContext): Observable<StrictHttpResponse<AuctionCatalogHierarchyDto>> {
  const rb = new RequestBuilder(rootUrl, patchAuctionCatalog.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuctionCatalogHierarchyDto>;
    })
  );
}

patchAuctionCatalog.PATH = '/api/auction-catalogs/{id}';
